export default "__VITE_ASSET__tjRC_34O__"